import { getOrgIdFromToken } from "@/api/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export function useOrgIdFromToken(): string | undefined {
  const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0();

  const [orgId, setOrgId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    getAccessTokenSilently()
      .then((token) => getOrgIdFromToken(token))
      .then((orgId) => setOrgId(orgId))
      .catch(() => setOrgId(undefined));
  }, [getAccessTokenSilently]);

  return orgId;
}
